// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__exNUZ","largestCol":"styles_largestCol__2VYyy","smallestCol":"styles_smallestCol__2uUYb"};